import { Component, Input, OnInit } from '@angular/core';
import { AreasAnualesModel } from 'src/app/model/FaseAnual.model';

@Component({
  selector: 'app-area-anual-seguimiento',
  templateUrl: './area-anual-seguimiento.component.html',
  styleUrls: ['./area-anual-seguimiento.component.css']
})
export class AreaAnualSeguimientoComponent implements OnInit {

  @Input() areaData : AreasAnualesModel;
  @Input() estadoSeguimientoAnio : number;

  cargando: boolean;
  readonly: boolean = false;

  public isCollapsed = true;

  constructor() { }

  ngOnInit(): void {
    this.cargaInicial();
  }
  cargaInicial(){
    if (this.estadoSeguimientoAnio !=0) {
      this.readonly = true;
    }
  }
}
